<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex"
import moment from "moment";
import Swal from "sweetalert2";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Shop Purchases Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      data: {
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        supplier: '',
        mode: '',
        branch_id: 0,
        title: 'Purchases Payments Report'
      },
      editdata: {
        id: "",
        amount: "",
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        supplier: '',
      },
      deletedata: {
        id: "",
        amount: "",
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        supplier: '',
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Purchase Payments Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Purchases Payments Report",
          active: true,
        },
      ],
      totalRows: 1,
      total_amount: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      filteredData: [],
      todofilterOn: [],
      sortDesc: false,
      json_fields: {
        DATE_TIME: "dateAdded",
        SUPPLIER: "supplier",
        AMOUNT: "amount",
        RECEIPT: "receipt",
        PAYMENTS_COUNT: "payments",
        PAYMENT_MODE: "mode",
        RECORDED_BY: "user",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      amountError: "",
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("purchase", ["PurchasePayments", "FilterStatus", "SaveStatus"]),
    ...mapGetters("stock", ["Suppliers"]),
    ...mapGetters("auth", ["MyUserPerm", "business", "branch", "Branches", "branchid"]),

    fields() {
      let baseFields = [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "dateAdded",
          sortable: true,
          label: "DATE TIME",
        },
        {
          key: "supplier",
          sortable: true,
          label: "SUPPLIER",
        },
        {
          key: "amount",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "receipt",
          sortable: true,
          label: "RECEIPT NO",
        },
        {
          key: "payments",
          sortable: true,
          label: "COUNT",
        },
        {
          key: "mode",
          sortable: true,
          label: "PAYMENT MODE",
        },
        {
          key: "user",
          sortable: true,
          label: "RECORDED BY",
        },
        {
          key: "actions",
          sortable: true,
          label: "ACTION",
        }
      ];
      if (this.branchid == 0) {
        baseFields.splice(8, 0,
          {
            key: "branch",
            sortable: true,
            label: "BRANCH",
          }
        );
      }
      return baseFields;
    },

    /**
     * Total no. of records
     */

    rows() {
      return this.filteredData ? this.filteredData.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.PurchasePayments ? this.PurchasePayments.length : 1;
  },
  methods: {
    ...mapActions({
      FetchPurchasesPayments: "purchase/fetchPurchasePayments",
      FetchSuppliers: "stock/fetchSuppliers",
      EditPayment: "purchase/EditPayment",
      DeletePayment: "purchase/DeletePayment",

    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    SetData() {
      if (this.PurchasePayments) {
        this.filteredData = this.PurchasePayments;
      }
    },
    filterReport() {
      this.FetchPurchasesPayments(this.data);
    },

    editAmt(modalId) {
      this.modal_id = modalId;
      this.editdata.datefrom = this.data.datefrom;
      this.editdata.dateto = this.data.dateto;
      this.editdata.supplier = this.data.supplier;
      if (this.editdata.amount == "") {
        this.amountError = "Amount field is required";
        return
      }
      else {
        this.amountError = "";
      }
      this.EditPayment(this.editdata).then(() => {
        this.FetchPurchasesPayments(this.data);
        this.closeModal(modalId);
      });
    },
    deletePayment(modalId) {
      this.modal_id = modalId;
      this.deletedata.datefrom = this.data.datefrom;
      this.deletedata.dateto = this.data.dateto;
      this.deletedata.supplier = this.data.supplier;
      this.DeletePayment(this.deletedata).then(() => {
        this.FetchPurchasesPayments(this.data);
        this.closeModal(modalId);
      });
    },
    addCommas() {
      this.editdata.amount = this.thousandSeperator(this.editdata.amount);
    },
    resetError() {
      this.amountError = "";
    },
    closeModal(modalId) {
      this.resetError();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    showEditModal(data) {
      this.editdata.amount = this.thousandSeperator(data.amount);
      this.editdata.id = data.id;
    },
    showDeleteModal(data) {
      this.deletedata.id = data.id;
      this.deletedata.amount = this.thousandSeperator(data.amount);
    },
    resetDelete() {
      this.deletedata.id = "";
      this.deletedata.amount = "";
    },
  },
  updated() {
    let total_amount = 0;
    if (this.filteredData) {
      this.filteredData.forEach((item) => {
        total_amount = total_amount + parseInt(item.amount);
      });
      this.total_amount = total_amount;
    }
  },
  watch: {
    PurchasePayments(newValue) {
      if (newValue) {
        this.SetData();
      }
    },
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  created() {
    this.SetData();
    this.FetchPurchasesPayments(this.data);
    this.FetchSuppliers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-8">
                <h3 class="card-title mb-2 text-center" v-html="data.title"></h3>
              </div>
              <div class="col-md-4 mb-3">
                <label>FILTER BY BRANCHES</label>
                <model-list-select :list="Branches ? [{ id: 0, name: 'All Branches' }, ...Branches] : []" v-model="data.branch_id" option-value="id"
                  option-text="name" placeholder="Select Branch" @input="filterReport()">
                </model-list-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <download-excel class="btn" style="
                    background-color: #e612e6 !important;
                    border-color: #e612e6 !important;
                    color: #fff !important;
                  " :data="filteredData" :fields="json_fields"
                  :worksheet="'PURCHASE PAYMENTS REPORT FOR' + currentdate" type="csv"
                  :name="'Purchasepayments_report' + currentdate + '.xls'">
                  Export Excel <i class="fa fa-file-excel"></i>
                </download-excel>
              </div>
              <div class="col-md-2 form-group mb-2">
                <label>FROM</label>
                <input type="date" v-model="data.datefrom" class="form-control" />
              </div>
              <div class="col-md-2 form-group">
                <label>TO</label>
                <input v-model="data.dateto" type="date" class="form-control" />
              </div>
              <div class="col-md-3 form-group">
                <label>SUPPLIER</label>
                <model-list-select :list="Suppliers ? Suppliers : []" v-model="data.supplier" option-value="id"
                  option-text="name" placeholder="Select Supplier">
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn" style="
                  background-color: #e612e6 !important;
                  border-color: #e612e6 !important;
                  color: #fff !important;
                " type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner v-show="FilterStatus" variant="light" small role="status"></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                      :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table class="datatables" :items="filteredData ? filteredData : []" :fields="fields" responsive="sm"
                :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc" :filter="filter"
                :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(amount)="data">
                  {{ thousandSeperator(data.item.amount) }}
                </template>
                <template #cell(actions)="data">
                  <div>
                    <b-dropdown text="More Actions..." size="sm" class="btn-primary"
                      v-if="MyUserPerm.modify_sales == 1 && branchid != 0">
                      <b-dropdown-item v-if="MyUserPerm.delete_purchase == 1" v-b-modal.delete-payment-modal
                        @click="showDeleteModal(data.item)">
                        <i class="fa fa-trash text-danger"></i> <span class="text-danger">Delete</span>
                      </b-dropdown-item>
                      <b-dropdown-item v-if="MyUserPerm.edit_purchase == 1" v-b-modal.edit-payment-modal
                        @click="showEditModal(data.item)"><i class="fa fa-edit"
                          style="background-color: #e612e6 !important; border-color: #e612e6 !important; color: #fff !important;"></i>
                        <span
                          style="background-color: #e612e6 !important; border-color: #e612e6 !important; color: #fff !important;">Edit</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </template>
              </b-table>
              <div class="row">
                <div class="col-md-5"></div>
                <div class="col-md-4">
                  <h5>Total Amount: <span class="text-danger">{{ thousandSeperator(total_amount) }}</span></h5>
                </div>
              </div>
              <!-- modal mark as expired starts -->
              <b-modal id="edit-payment-modal" hide-footer>
                <template #modal-title>
                  <h4 class="text-warning">Edit Purchase Payment</h4>
                </template>
                <label>Amount Paid</label>
                <div class="input-group">
                  <input type="text" class="form-control" v-model="editdata.amount" placeholder="Enter actual amount"
                    @input="resetError(), addCommas()" />
                </div>
                <div class="text-danger" v-if="amountError">
                  <em>{{ amountError }}</em>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal"
                    @click="closeModal('edit-payment-modal')">
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button type="button" class="btn btn-warning" @click="editAmt('edit-payment-modal')">
                    <i class="fa fa-minus"></i> Confirm
                    <b-spinner v-if="SaveStatus" variant="light" small label="Submiting"></b-spinner>
                  </button>
                </div>
              </b-modal>
              <!-- modal ends -->
              <!--Payment delete modal starts -->
              <b-modal header-bg-variant="danger" header-text-variant="light" body-text-variant="danger"
                footer-bg-variant="danger" footer-text-variant="danger" id="delete-payment-modal" hide-footer
                @hidden="resetDelete">
                <template #modal-title> Delete Payment of amount {{ thousandSeperator(deletedata.amount) }}</template>
                <div class="form-group mb-2">
                  <div class="input-group">
                    <h5>
                      Do you want to delete this Payment? Click Proceed Button to delete.
                    </h5>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal"
                    @click="closeModal('delete-payment-modal')">
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button type="button" class="btn btn-danger" @click="deletePayment('delete-payment-modal')">
                    <i class="fa fa-minus"></i> Proceed
                    <b-spinner v-if="SaveStatus" variant="light" small label="Submiting"></b-spinner>
                  </button>
                </div>
              </b-modal>
              <!-- modal ends -->
            </div>
            <Loader v-if="!filteredData" />
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #FAB031 !important;
  border-color: #FAB031 !important;
}
</style>
